import React, { useContext } from "react"
import { useCurrentUser } from "#/components/context/user/UserContext"
import { Button, DialogActions, DialogContent, DialogTitle, Typography } from "@carrotfertility/carotene-core"
import { FormattedMessage } from "react-intl"
import { Link as RouterLink } from "react-router-dom"
import { OriginDialogContext } from "#/components/telemedicine/pelvic-floor-therapy/OriginDialogContext"
import { useOriginStepTracking } from "#/components/telemedicine/pelvic-floor-therapy/hooks/useOriginStepTracking"

export function ResendPartnerInviteStep(): JSX.Element {
  const { setOpenDialogFlow } = useContext(OriginDialogContext)
  const { partnerPreferredName, partnerFirstName, preferredName, firstName } = useCurrentUser()
  const { trackButtonClick } = useOriginStepTracking("Resend partner invite")
  const memberName = preferredName ?? firstName
  const partnerName = partnerPreferredName ?? partnerFirstName

  const handleResendInvite = () => {
    trackButtonClick({ name: "Resend invite", href: "/account#partnerAccessFooterContainer" })
  }

  const handleClose = () => {
    trackButtonClick({ name: "Close" })
    setOpenDialogFlow(false)
  }

  return (
    <>
      <DialogTitle>
        <FormattedMessage defaultMessage="Verify {partnerName}'s email" values={{ partnerName }} />
      </DialogTitle>
      <DialogContent>
        <Typography>
          <FormattedMessage
            defaultMessage="An invitation to join {memberName}'s Carrot account was previously sent to {partnerName}'s email. Verify {partnerName}'s email address and create a password to access pelvic floor therapy through Origin."
            values={{ partnerName, memberName }}
          />
        </Typography>
        <Typography>
          <FormattedMessage defaultMessage="Can't find the email? Resend the invite." />
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="secondary"
          component={RouterLink}
          to="/account#partnerAccessFooterContainer"
          onClick={handleResendInvite}
        >
          <FormattedMessage defaultMessage="Resend invite" />
        </Button>
        <Button onClick={handleClose}>
          <FormattedMessage defaultMessage="Close" />
        </Button>
      </DialogActions>
    </>
  )
}
